export interface IDashBoardAPI {
  monthsList: string;
  approvedExpenses: string;
  rejectedExpenses: string;
  pendingInvite: string;
  notInvited: string;
  activeEmp: string;
  mileage: string;
  mileageGoogle: string;
  mileageGPS: string;
  responseInfo: DashBoardAPI;
}
export class DashBoardAPI implements IDashBoardAPI {
  responseInfo: DashBoardAPI;
  monthsList: string;
  approvedExpenses: string;
  rejectedExpenses: string;
  pendingInvite: string;
  notInvited: string;
  activeEmp: string;
  mileage: string;
  mileageGoogle: string;
  mileageGPS: string;
}

export class DashboardDataRequest {
  orgId: number;
  userId: number;
  requestCountType: number;
  loginId: string;
}

export class RespGetVendorActionableCount {
  reqForReviewCount: number;
  reqForFinanceReviewCount: number;
  draftPurchaseOrderCount: number;
  finalPurchaseOrderCount: number;
  reportAnalysisCount: number;
  listOfDraftOrderCount: number;
  invoiceForFinanceReviewCount: number;
  invoiceForPayCount: number;
  unallocatedInvoiceCount: number;
  partiallyAllocatedInvoiceCount: number;
  fullyAllocatedInvoiceCount: number;
  rejectedReqCount: number;
  rejectedInvoiceCount: number;
  incompleteInvoiceCount: number;
}

